import angular from 'angular';

export class SearchHistoryComponent {
    /* @ngInject */
    constructor($stateParams) {
        const searchMainCtrl = this;

        searchMainCtrl.data = {
            currSearchHistoryIndex: $stateParams.history.value || 0,
            currCandidatePage: $stateParams.page.value || 0,
            talentID: $stateParams.talentID.value || 0,
            scroll: $stateParams.scroll.value || 0,
            searchName: $stateParams.searchName.value || null,
            showView: 'MainSearch',
            candidatesName: $stateParams.candidatesName.value || null,
        };
    }
}

export const SearchHistoryComponentConfiguration = {
    template: '<search-component-new search-data="searchMainCtrl.data"></search-component-new>',
    controller: SearchHistoryComponent,
    controllerAs: 'searchMainCtrl',
};

angular.module('TALENYA-FE').component('searchHistoryNew', SearchHistoryComponentConfiguration);
